import MapperBase from '../MapperBase.js';
import PlateAppearanceResult from '../../enums/PlateAppearanceResult.js';

class MlbPlateAppearanceResultMapper extends MapperBase {
    constructor(silent) {
        super(silent, PlateAppearanceResult.Unidentified.key);
    }

    mapSingle(item) {
        // Unfortunately there is no api doc containing all possible values for this...
        // found some values using JSON Path liveData.plays.allPlays[*].result
        switch (item.eventType) {
            case 'field_out': // Groundout, Flyout
            case 'double_play': // Double play
            case 'triple_play': // Triple Play
            case 'force_out': // Forceout
            case 'grounded_into_double_play': // Grounded Into DP
                return PlateAppearanceResult.FieldOut.key;
            case 'single': // Single
                return PlateAppearanceResult.Single.key;
            case 'double': // Double
                return PlateAppearanceResult.Double.key;
            case 'triple': // Triple
                return PlateAppearanceResult.Triple.key;
            case 'home_run': // Home Run
                return PlateAppearanceResult.HomeRun.key;
            case 'fielders_choice_out': // Fielders Choice Out
            case 'fielders_choice': // Fielders Choice
                return PlateAppearanceResult.FieldersChoice.key;
            case 'field_error': // Field Error
                return PlateAppearanceResult.ReachedOnError.key;
            case 'hit_by_pitch': // Hit By Pitch
                return PlateAppearanceResult.HitByPitch.key;
            case 'intent_walk': // Intent Walk
                return PlateAppearanceResult.IntentionalWalk.key; // TODO - check it
            case 'strikeout': // Strikeout
                // TODO - not the most elegant way
                return item.description.indexOf('strikes out swinging') > -1
                    ? PlateAppearanceResult.SwingingStrikeout.key
                    : PlateAppearanceResult.CalledStrikeout.key;
            case 'walk': // Walk
                return PlateAppearanceResult.Walk.key;
            case 'sac_bunt': // Sac Bunt
                return PlateAppearanceResult.SacrificeBunt.key;
            case 'sac_fly': // Sac Fly
                return PlateAppearanceResult.SacrificeFly.key;

            default:
                // unfortunately I coulnd't find ANY source of all possible pa results, so I was digging through MLB Pitch Data DB... @see https://www.kaggle.com/pschale/mlb-pitch-data-20152018
                switch (item.event) {
                    case 'Batter Interference':
                        return PlateAppearanceResult.BatterInterference.key;
                    case 'Bunt Groundout':
                    case 'Bunt Lineout':
                    case 'Bunt Pop Out':
                        return PlateAppearanceResult.FieldOut.key;
                    case 'Catcher Interference':
                        return PlateAppearanceResult.CatcherInterference.key;
                    case 'Caught Stealing 2B':
                    case 'Caught Stealing 3B':
                    case 'Caught Stealing Home':
                        return PlateAppearanceResult.NotAvailable.key;
                    case 'Fan Interference':
                        // TODO - review this, maybe we apply some better pa result here
                        return PlateAppearanceResult.NotAvailable.key;
                    case 'Passed Ball':
                        return PlateAppearanceResult.PassedBall.key;
                    case 'Pickoff 1B':
                    case 'Pickoff 2B':
                    case 'Pickoff 3B':
                    case 'Pickoff Caught Stealing 2B':
                    case 'Pickoff Caught Stealing 3B':
                    case 'Pickoff Caught Stealing Home':
                    case 'Pickoff Error 1B':
                        // TODO - review this, I'm not sure if this is the case, I've assumed that inning is over because one o the runner was pciked off...
                        return PlateAppearanceResult.NotAvailable.key;
                    case 'Runner Double Play':
                    case 'Runner Triple Play':
                    case 'Runner Out':
                        // TODO - not sure what it is
                        return PlateAppearanceResult.NotAvailable.key;
                    case 'Sac Bunt Double Play':
                    case 'Sacrifice Bunt DP':
                    case 'Sac Bunt Triple Play':
                    case 'Sacrifice Bunt TP':
                        return PlateAppearanceResult.SacrificeBunt.key;
                    case 'Sac Fly DP':
                    case 'Sac Fly Double Play':
                    case 'Sac Fly TP':
                    case 'Sac Fly Triple Play':
                        return PlateAppearanceResult.SacrificeFly.key;
                    case 'Stolen Base 2B':
                    case 'Stolen Base 3B':
                    case 'Stolen Base Home':
                        // TODO - not sure what it is
                        return PlateAppearanceResult.NotAvailable.key;
                    case 'Strikeout - DP':
                    case 'Strikeout Double Play':
                    case 'Strikeout - TP':
                    case 'Strikeout Triple Play':
                         // TODO - not the most elegant way
                        return item.description.indexOf('strikes out swinging') > -1
                            ? PlateAppearanceResult.SwingingStrikeout.key
                            : PlateAppearanceResult.CalledStrikeout.key;
                    case 'Wild Pitch':
                        return PlateAppearanceResult.WildPitch.key;
                }
                break;
        }

        throw new Error(`Unable to map plate apperance result ${item.event} - ${item.eventType}`);
    }
}

export default MlbPlateAppearanceResultMapper;